module.exports = __webpack_public_path__ + "static/img/header-shape.65d035f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interthings/header-shape.png
// module id = 3JT4
// module chunks = 4